import { Span, Text } from "@tblabs/truffle";
import { Center } from "../Components/Center";
import { DangerButton } from "../Components/DangerButton";
import { Router } from "../Services/Router";
import { Page } from "./Page";
import { Panel } from "../Components/Panel";
import { OffersRepo } from "../Services/OffersRepo";


export class OfferPreview extends Page
{
    constructor(
        private _offers: OffersRepo,
        private _router: Router,
        private offerId: string)
    {
        super("Oferta pracy");

        this.Content(async () =>
        {
            const offer = await this._offers.Get(this.offerId);

            this.body.Append(
                new Panel(new Span(offer.Title.value).FontSize(32).Bold(), [
                    new Text(offer.IsRecruitmentOpen.value ? "✅ Rekrutacja otwarta" : "✖️ Rekrutacja zamknięta").Margin(8),
                ]),
                ...offer.Description.Items
                    .map(x => new Panel(x.Label.value, [x.Text.value])),
                new Center(
                    new DangerButton("Aplikuj!", () => this._router.GoToApplyFormPage(offer))
                        .Enable(offer.IsRecruitmentOpen)
                ).MarginTop(32)
            )
        });
    }
}
